import React from "react";

import { FEATURE_TYPE } from "@constants/unitDetails";
import {
  FeaturesPropType,
  FeatureType,
} from "@models/components/organisation.model";
import { LocalizationObjectType } from "@models/utils/localisation.models";
import { applyLocalization } from "@services/common.service";

const Features: React.FC<FeaturesPropType> = ({
  features,
  label,
  showBottomBorder = true,
  type,
}) => {
  const getFeatureValue = (
    feature: LocalizationObjectType | FeatureType
  ): string => {
    return type === FEATURE_TYPE.INFO
      ? (feature.default as string)
      : applyLocalization(feature as LocalizationObjectType);
  };

  const style = `fg-tab-unit-list ${
    type === FEATURE_TYPE.FEATURE && !showBottomBorder ? "fg-border-none" : ""
  }`;

  const featureCount: number = features?.filter(
    feature => getFeatureValue(feature)?.trim() != ""
  ).length;

  if (featureCount == 0) return;

  return (
    <div className={style} data-testid="features">
      <h5>{label}</h5>
      <div className="fg-info-bubble-wrap">
        {features?.length > 0 &&
          features?.map((feature, index) => {
            const featureValue = getFeatureValue(feature)?.trim();
            if (!featureValue) return null;

            const headingValue =
              type === FEATURE_TYPE.LABEL
                ? applyLocalization(feature as LocalizationObjectType)
                : feature?.title
                  ? `${feature.title}`
                  : "";
            return (
              <div
                className="fg-info-bubble"
                key={index}
                data-testid="featureBox"
              >
                {headingValue && <h6>{headingValue}</h6>}

                {type !== FEATURE_TYPE.LABEL && (
                  <p>{getFeatureValue(feature)}</p>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Features;
